import request from ".";

export const membersApi = {
  getMembersById: (id: string) =>
    request.post(`BoardsMembers/getBoardsMembersByUniqueUrl?UniqueUrl=${id}`),
  // getMember: (member: string) =>
  //   request.post(`BoardsMembers/getBoardsMembersById?BoardsId=${member}`),
  getAllMembers: () => request.post("BoardsMembers/getAllBoardsMembers"),
  getFacultyMembers: (
    page: number,
    size: number,
    search: string,
    collegeId: string
  ) =>
    request.post(
      `FacultyMembers/getAllFacultyMembersFilterPagination?CollegeId=${collegeId}&FullName=${search}&countPerPage=${size}&Page=${page}`
    ),
  getProfile: (id: string) =>
    request.post(`FacultyMembers/GetByUniqueURLAll?UniqueUrl=${id}`),
};
